export const DASHBOARD_PERIOD_PRESETS = [
  { value: 'all_time', label: 'All time' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_30_days', label: 'Last 30 days' },
  { value: 'month_to_date', label: 'Month to date' },
  { value: 'monthly', label: 'Last full month' },
  { value: 'last_3_months', label: 'Last 3 months' },
  { value: 'last_6_months', label: 'Last 6 months' },
  { value: 'last_9_months', label: 'Last 9 months' },
  { value: 'last_12_months', label: 'Last 12 months' },
  { value: 'year_to_month', label: 'Year to month' },
  { value: 'this_year', label: 'This year' },
  { value: 'last_year', label: 'Last year' },
  { value: 'custom_range', label: 'Custom range' },
];

export function formatDateForApi(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function addDays(date, days) {
  const next = new Date(date);
  next.setDate(next.getDate() + days);
  return next;
}

export function getDashboardDateRangeFromPreset(preset) {
  if (!preset || preset === 'all_time') {
    return { start_date: '', end_date: '' };
  }

  const today = startOfDay(new Date());
  let start = today;
  let end = today;

  switch (preset) {
    case 'today':
      break;
    case 'yesterday':
      start = addDays(today, -1);
      end = addDays(today, -1);
      break;
    case 'last_7_days':
      start = addDays(today, -6);
      break;
    case 'last_30_days':
      start = addDays(today, -29);
      break;
    case 'month_to_date':
      start = new Date(today.getFullYear(), today.getMonth(), 1);
      break;
    case 'monthly':
      start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      end = new Date(today.getFullYear(), today.getMonth(), 0);
      break;
    case 'last_3_months':
      start = addDays(today, -89);
      break;
    case 'last_6_months':
      start = addDays(today, -179);
      break;
    case 'last_9_months':
      start = addDays(today, -269);
      break;
    case 'last_12_months':
      start = addDays(today, -364);
      break;
    case 'year_to_month':
      start = new Date(today.getFullYear(), 0, 1);
      end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;
    case 'this_year':
      start = new Date(today.getFullYear(), 0, 1);
      break;
    case 'last_year':
      start = new Date(today.getFullYear() - 1, 0, 1);
      end = new Date(today.getFullYear() - 1, 11, 31);
      break;
    case 'custom_range':
      return { start_date: '', end_date: '' };
    default:
      return { start_date: '', end_date: '' };
  }

  return {
    start_date: formatDateForApi(start),
    end_date: formatDateForApi(end),
  };
}

export function buildDashboardStatsQuery({ preset, startDate, endDate }) {
  if (preset === 'all_time') return {};

  const start = String(startDate || '').trim();
  const end = String(endDate || '').trim();
  if (!start || !end) return null;

  if (end < start) return null;

  return {
    start_date: start,
    end_date: end,
  };
}

export function formatDashboardRangeLabel(startDate, endDate) {
  if (!startDate && !endDate) return 'All time';
  if (startDate && endDate) return `${startDate} — ${endDate}`;
  return '';
}
